// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time__task--error .mx-input-wrapper {\n  border: 1px solid #ff3d60;\n  border-radius: 5px;\n}\n.custom--time__task .mx-input-wrapper .mx-input:disabled {\n  color: #505d69;\n}", ""]);
// Exports
module.exports = exports;
